import {
    AgentSkill,
    AgentSkillLibraryItem,
    AgentSkillSyncOrganizationsResponse,
    AgentSkillSyncPreviewRequest,
    AgentSkillSyncPreviewResponse,
    AgentSkillSyncRequest,
    AgentSkillSyncResponse,
} from "components/AgentSkills/Models/AgentSkill";
import { BaseService } from "./BaseService";

export class AgentSkillLibraryService extends BaseService {
    protected urlBase = "api/AgentSkillLibrary";

    public getLibrary(abortSignal?: AbortSignal) {
        return this.get<AgentSkillLibraryItem[]>(
            new URLSearchParams(),
            "",
            abortSignal,
        );
    }

    public addToLibrary(skillId: string) {
        return this.post<{ message: string }>(
            "",
            new URLSearchParams({ skillId }),
            "AddToLibrary",
        );
    }

    public removeFromLibrary(skillId: string) {
        return this.post<{ message: string }>(
            "",
            new URLSearchParams({ skillId }),
            "RemoveFromLibrary",
        );
    }

    public addFromLibrary(libraryId: string) {
        return this.post<AgentSkill>(
            "",
            new URLSearchParams({ libraryId }),
            "AddFromLibrary",
        );
    }

    public updateFromLibrary(tenantSkillId: string, libraryId: string) {
        return this.post<AgentSkill>(
            "",
            new URLSearchParams({ tenantSkillId, libraryId }),
            "UpdateFromLibrary",
        );
    }

    public getSyncOrganizations() {
        return this.get<AgentSkillSyncOrganizationsResponse>(
            new URLSearchParams(),
            "organizations",
        );
    }

    public previewSync(request: AgentSkillSyncPreviewRequest) {
        return this.post<AgentSkillSyncPreviewResponse>(
            JSON.stringify(request),
            new URLSearchParams(),
            "sync/preview",
        );
    }

    public syncToTenants(request: AgentSkillSyncRequest) {
        return this.post<AgentSkillSyncResponse>(
            JSON.stringify(request),
            new URLSearchParams(),
            "sync",
        );
    }
}

export default AgentSkillLibraryService;
